export enum CopType {
	BUILDER = 'builder',
	BUILDER_2D_ARRAY = 'builder2DArray',
	CUBE_MAP = 'cubeMap',
	CUBE_CAMERA = 'cubeCamera',
	CUBE_MAP_FROM_SCENE = 'cubeMapFromScene',
	ENV_MAP = 'envMap',
	SDF_BLUR = 'SDFBlur',
	SDF_FROM_OBJECT = 'SDFFromObject',
	SDF_FROM_URL = 'SDFFromUrl',
	SNAPSHOT = 'snapshot',
	VIDEO = 'video',
	WEB_CAM = 'webCam',
}

export enum CopTypeImage {
	IMAGE = 'image',
	IMAGE_EXR = 'imageEXR',
	IMAGE_HDR = 'imageHDR',
	IMAGE_KTX2 = 'imageKTX2',
}
